import { useEffect, useState } from "react";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { MessageCircle, RefreshCw } from "lucide-react";
import { reminderApi, buildReminderMessage, waLink } from "@/lib/agenda";

export const ReminderMessageDialog = ({ open, appointment, onClose, onSent }) => {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const generate = async () => {
    if (!appointment) return;
    setLoading(true);
    try {
      const phrase = await reminderApi.phrase();
      setMessage(buildReminderMessage(appointment, phrase));
    } catch (e) {
      toast.error("Algo no ha ido bien. Prueba otra vez o vuelve más tarde.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open && appointment) generate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, appointment?.id]);

  if (!appointment) return null;

  const handleSend = () => {
    if (onSent) onSent(appointment);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-[480px] rounded-3xl" data-testid="reminder-message-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl text-slate-900">Recordatorio listo</DialogTitle>
          <DialogDescription className="text-sm text-slate-500">
            Revisa el mensaje y envíalo por WhatsApp. Puedes editarlo o pedir otra frase.
          </DialogDescription>
        </DialogHeader>

        <Textarea
          value={loading ? "Preparando el mensaje..." : message}
          onChange={(e) => setMessage(e.target.value)}
          rows={7}
          disabled={loading}
          className="text-sm leading-relaxed"
          data-testid="reminder-message-text"
        />

        <div className="flex items-center justify-between gap-2 pt-1">
          <Button
            type="button"
            variant="outline"
            onClick={generate}
            disabled={loading}
            className="rounded-full gap-1.5"
            data-testid="regenerate-phrase"
          >
            <RefreshCw className={`h-4 w-4 ${loading ? "animate-spin" : ""}`} />
            Otra frase
          </Button>
          <a
            href={waLink(appointment.client_phone, message)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleSend}
            data-testid="send-whatsapp-button"
            className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-white text-sm font-medium"
            style={{ backgroundColor: "#0E9F6E" }}
          >
            <MessageCircle className="h-4 w-4" />
            Enviar por WhatsApp
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
};
